import { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormPageApp } from './FormPageAppContext';
import AnalyteLimitInfo from './AnalyteLimitInfo';


function TaskActionsMenu({ children }) {
  return (
    <div className="dropdown">
      <button
        className="btn lk-button dropdown-toggle px-4"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Действия
      </button>
      <ul className="dropdown-menu">
        {children}
      </ul>
    </div>
  );
}


function CourierCallAction({ courierCall }) {
  const navigate = useNavigate();

  if (courierCall.ticket_id) {
    return (
      <button
        className="dropdown-item lk-menu-dropdown"
        data-bs-toggle="modal"
        data-bs-target="#courierRequestSentModal"
      >
        Вызов курьера
      </button>
    );
  }

  return (
    <button
      className="dropdown-item lk-menu-dropdown"
      onClick={() => navigate('courier')}
    >
      Вызов курьера
    </button>
  );
}


export default function FormHeaderLab({ taskId, taskUrl, taskParams, selectedAnalytesCount }) {
  const { apiClient, apiUrlContext, authTokenContext, ConfirmationModal } =
    useFormPageApp();
  const api_url = useContext(apiUrlContext);
  const token = useContext(authTokenContext);
  const navigate = useNavigate();

  const courierCall = taskParams.courier_call;
  const courierCallVisible = Boolean(courierCall?.enabled && courierCall?.available);

  function requestTaskReturnClick(id) {
    const params = { operation: 'request-task-return' };

    apiClient
      .put(api_url + taskUrl + taskId, params, {
        headers: {
          Authorization: token,
        },
      })
      .then(
        () => {
          navigate(0);
        },
        (error) => {
          console.log(error);
          alert(error.response?.data || 'Не удалось запросить возврат задания');
        }
      );
  }

  return (
    <>
      <ConfirmationModal
        modalId="confirmTaskReturnRequestModal"
        headerText="Задание"
        messageText={['Вы уверены, что хотите запросить возврат задания?']}
        confirmButtonText="Запросить возврат"
        Action={() => requestTaskReturnClick(taskId)}
      />

      {courierCall?.ticket_id &&
        <ConfirmationModal
          modalId="courierRequestSentModal"
          headerText="Вызов курьера"
          messageText={['Заявка на вызов курьера отправлена']}
          confirmButtonText="Открыть обращение"
          Action={() => navigate(`/results/tickets/${courierCall.ticket_id}`)}
        />
      }

      {['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status) ?
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3 d-grid gap-3 d-md-flex justify-content-between">
                  <div>
                    <h6 className="mb-0">Задание отправлено на проверку</h6>
                    {taskParams.return_requested && <p className='mt-3'><small>отправлен запрос на возврат задания</small></p>}
                  </div>
                  <div className="d-flex flex-column align-items-end mt-3 me-3">
                    <TaskActionsMenu>
                      {taskParams.return_requested ? (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          disabled
                        >
                          Запрос на возврат отправлен
                        </button>
                      ) : (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          data-bs-toggle="modal"
                          data-bs-target="#confirmTaskReturnRequestModal"
                        >
                          Запросить возврат задания
                        </button>
                      )}
                      {courierCallVisible && <CourierCallAction courierCall={courierCall} />}
                    </TaskActionsMenu>
                    <div className="mt-auto pt-2">
                      <Link to="history" className="small text-end d-inline-block">
                        Просмотр истории задания
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>   
          </>
        )
      :
        ( 
          <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '30px'}}>
            <div className='col-9 ps-0'>
              <div className="form-head p-3">
                <div className="d-grid gap-3 d-md-flex justify-content-between">
                  <div>
                    <h6>Цикл: <b>{taskParams.form?.cycle}</b></h6>
                    <h6>Представление результатов до: <b>{taskParams.deadline_date}</b></h6>
                    <h6>Номера ОПК: {taskParams.samples}</h6> 
                    <AnalyteLimitInfo limit={taskParams.analyte_limit} selectedCount={selectedAnalytesCount} />
                  </div>
                  {taskParams.status === 'CHECKED' && courierCallVisible &&
                    <div className="mt-3 me-3">
                      <TaskActionsMenu>
                        <CourierCallAction courierCall={courierCall} />
                      </TaskActionsMenu>
                    </div>
                  }
                </div>
                {taskParams.status === 'CHECKED' &&
                  <h6 className="mt-3">
                    Задание проверено. Отчет о результатах исследований доступен на странице <Link to="/results/reports">«Результаты»</Link>
                  </h6>
                }
                <div className="text-end mt-2">
                  <Link to="history" className="small d-inline-block">
                    Просмотр истории задания
                  </Link>
                </div>
              </div>
            </div>
          </div> 
        )
      }

      {taskParams.status === 'PENDING' &&
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3">
                  <h6><span className="text-danger fw-bold">Задание станет доступно для редактирования начиная с {taskParams.start_date}</span></h6>
                </div>
              </div>
            </div>   
          </>
        )
      }      
    </>
  )
}
